import React, {ReactNode, useEffect, useRef, useState} from 'react';
import {useChildHeight} from "@Hooks/refs/useChildHeight";
import IconChevron from "@Icons/chevrons/IconChevron";

interface ExpandableContainerProps {
    children: ReactNode,
    loadMoreLabel?: string | ReactNode,
}

function ExpandableContainer({children, loadMoreLabel = 'Read more'}: ExpandableContainerProps) {
    const ref = useRef(null);
    const [expanded, expand] = useState(true)
    const height = useChildHeight(ref)

    useEffect(() => {
        expand(height <= 120)
    }, [height]);

    return (
        <>
            <div
                ref={ref}
                onClick={() => expand(true)}
                className={`gb--expandable-container ${expanded ? 'expanded' : 'closed'}`}
            >
                <div>
                    {children}
                </div>
            </div>
            {!expanded && (
                <span onClick={() => expand(true)} className="gb--expand-action">
                    {loadMoreLabel}
                    <IconChevron
                        width="20"
                        fill="#4a79e2"
                        style={{verticalAlign: 'text-bottom'}}
                        chevronOrientation="down"
                    />
                </span>
            )}
        </>
    );
}

export default ExpandableContainer;